var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import NewVersionService from "ember-cli-new-version/services/new-version";

/**
 * This class implements the logic of our app when a new version of the front is detected.
 * It relies on the ember-cli-new-version addon which regularly fetches a VERSION.txt file at the root of the server.
 * This file contains the version of the app. If the content is different from the version of the running app, the page is reloaded.
 *
 * The VERSION.txt file is automatically created by ember-cli-new-version.
 * To test the feature on your machine, create your own VERSION.txt file in lib/core/public.
 * This will override the file created at build time by ember-cli-new-version.
 */
let SemeiaNewVersionService = (_class = class SemeiaNewVersionService extends NewVersionService {
  constructor(owner) {
    super(owner);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _defineProperty(this, "autoreloadRoutes", new Set(["login.index", "login.medic-password", "medics-web.protected.index.alerts-and-notifications", "medics-web.protected.index.tasks-and-consultations", "medics-web.protected.index.patient-list", "login.patient-link", "patient-web.protected.dashboard.index"]));
    this.router.on("routeDidChange", this._automaticReloadIfNeeded.bind(this));
  }
  onNewVersion() {
    this._automaticReloadIfNeeded();
  }
  reload() {
    window.location.reload();
  }
  _automaticReloadIfNeeded() {
    if (this.isNewVersionAvailable) {
      const currentRouteName = this.router.currentRouteName;
      if (currentRouteName && this.autoreloadRoutes.has(currentRouteName)) {
        this.reload();
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SemeiaNewVersionService as default };